import { AxiosPromise } from "axios";
import service from "../apis/Service";
import DtoSelectSearchParamPriceField from "../models.machine/DtoSelectSearchParamPriceField";
import RESTfulResult from "../models.machine/RESTfulResult";
import UiSelectOption from "../models.machine/UiSelectOption";
import DtoPageListSearchParamPriceField from "../models.machine/DtoPageListSearchParamPriceField";
import DtoPageListParamPriceField from "../models.machine/DtoPageListParamPriceField";
import UiTreeDrag from "../models.machine/UiTreeDrag";
import DtoDetailParamPriceField from "../models.machine/DtoDetailParamPriceField";
import DtoFormParamPriceField from "../models.machine/DtoFormParamPriceField";

/**
 * 价格要素
 * @description 自动生成的代码,请勿修改
 */
export default class ParamPriceFieldAppService {
    /**
     * 获取价格要素选择器
     * @param {DtoSelectSearchParamPriceField} [search] 搜索条件
     * @returns {AxiosPromise<RESTfulResult<UiSelectOption<string>[]>>} 选择器
     */
    static GetSelect(search?: DtoSelectSearchParamPriceField): AxiosPromise<RESTfulResult<UiSelectOption<string>[]>> {
        const url = `/api/ParamPriceField/GetSelect`;
        return service.get<RESTfulResult<UiSelectOption<string>[]>>(url, { params: search });
    }

    /**
     * 获取价格要素分页列表
     * @param {DtoPageListSearchParamPriceField} [dto] 搜索条件
     * @returns {AxiosPromise<RESTfulResult<DtoPageListParamPriceField>>} 分页列表
     */
    static Get(dto?: DtoPageListSearchParamPriceField): AxiosPromise<RESTfulResult<DtoPageListParamPriceField>> {
        const url = `/api/ParamPriceField/Get`;
        return service.get<RESTfulResult<DtoPageListParamPriceField>>(url, { params: dto });
    }

    /**
     * 拖曳排序
     * @param {UiTreeDrag<string>} [dto] 传参
     * @returns {AxiosPromise<RESTfulResult<any>>} 
     */
    static DragSort(dto?: UiTreeDrag<string>): AxiosPromise<RESTfulResult<any>> {
        const url = `/api/ParamPriceField/DragSort`;
        return service.post<RESTfulResult<any>>(url, dto);
    }

    /**
     * 获取价格要素详细
     * @param {string} [id] Id
     * @returns {AxiosPromise<RESTfulResult<DtoDetailParamPriceField>>} 详细
     */
    static GetById(id?: string): AxiosPromise<RESTfulResult<DtoDetailParamPriceField>> {
        const url = `/api/ParamPriceField/Get/${id}`;
        return service.get<RESTfulResult<DtoDetailParamPriceField>>(url);
    }

    /**
     * 新增/编辑价格要素
     * @param {DtoFormParamPriceField} [dto] 表单
     * @returns {AxiosPromise<RESTfulResult<string>>} Id
     */
    static Post(dto?: DtoFormParamPriceField): AxiosPromise<RESTfulResult<string>> {
        const url = `/api/ParamPriceField/Post`;
        return service.post<RESTfulResult<string>>(url, dto);
    }

    /**
     * 批量删除价格要素
     * @param {string[]} [ids] Id
     * @returns {AxiosPromise<RESTfulResult<any>>} 
     */
    static Delete(ids?: string[]): AxiosPromise<RESTfulResult<any>> {
        const url = `/api/ParamPriceField/Delete`;
        return service.delete<RESTfulResult<any>>(url, { data: ids });
    }

}
